import styled from "styled-components";

export const Fieldset = styled.fieldset`
    border: 1px solid #e2e1de;
    margin: 10px 0;
    padding: 10px 8.4px;

    @media print {
        border: 0;
    }

    legend {
        font-family: vag-rounded-thin, sans-serif;
        cursor: pointer;
        font-size: 1.25em;
        color: ${props => props.theme.primary};
    }

    legend span {
        color: ${props => props.theme.primary};
    }

    legend span i {
        color: ${props => props.theme.secondary};
        padding: 0 3px 0;
        float: left;
    }
`;
